import { usePrevious } from '@as/cotopaxi';
import { useFormikContext } from 'formik';
import { useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
export const ReturnItemsChangeHandler = () => {
    const { values } = useFormikContext();
    const dispatch = useDispatch();
    const selectedItemsCount = useMemo(() => {
        return values.saleLines.filter(saleLine => !!saleLine.isSelected).length;
    }, [values.saleLines]);
    const previousCount = usePrevious(selectedItemsCount);
    useEffect(() => {
        if (previousCount === null)
            return;
        const currentCount = values.saleLines.filter(saleLine => !!saleLine.isSelected).length;
        if (previousCount < currentCount) {
            dispatch(analyticsActions.returnProductSelected());
        }
        else if (previousCount > currentCount) {
            dispatch(analyticsActions.returnProductUnselected());
        }
    }, [values.saleLines]);
    useEffect(() => {
        if (!values.returnOptionId)
            return;
        dispatch(analyticsActions.returnMethodSelected(values.returnOptionId));
    }, [values.returnOptionId]);
    return null;
};
